import { createListenerMiddleware } from '@reduxjs/toolkit';

import { capsulesApi } from './capsules.api';
import { removeCapsule, setCapsules, upsertCapsule } from './capsule.slice';

export const capsulesListenerMiddleware = createListenerMiddleware();

capsulesListenerMiddleware.startListening({
  matcher: capsulesApi.endpoints.getCapsules.matchFulfilled,
  effect: (action, listenerApi) => {
    const normalizedList = action.payload;
    listenerApi.dispatch(setCapsules(normalizedList));
  },
});

capsulesListenerMiddleware.startListening({
  matcher: capsulesApi.endpoints.getCapsule.matchFulfilled,
  effect: (action, listenerApi) => {
    const capsule = action.payload;
    listenerApi.dispatch(upsertCapsule(capsule));
  },
});

capsulesListenerMiddleware.startListening({
  matcher: capsulesApi.endpoints.createCluster.matchFulfilled,
  effect: (action, listenerApi) => {
    listenerApi.dispatch(upsertCapsule(action.payload));
  },
});

capsulesListenerMiddleware.startListening({
  matcher: capsulesApi.endpoints.updateCapsule.matchFulfilled,
  effect: (action, listenerApi) => {
    listenerApi.dispatch(upsertCapsule(action.payload));
  },
});

capsulesListenerMiddleware.startListening({
  matcher: capsulesApi.endpoints.deleteCapsule.matchFulfilled,
  effect: (action, listenerApi) => {
    const capsuleId = action.meta.arg.originalArgs as string;
    listenerApi.dispatch(removeCapsule(capsuleId));
  },
});
